import Reflux from "reflux";
import { callWebUtils } from "../../../../Components/CampaignMembers/helpers";

const INIT = {
  getMultipleMediaAssetByIds: { asyncResult: true },
  deleteMultipleMediaAssets: { asyncResult: true }
};

const Actions = Reflux.createActions(INIT);

Actions.getMultipleMediaAssetByIds.listen(function (mediaAssetIds) {
  const filteredMediaAssetIds = mediaAssetIds.filter((mediaAssetId) => !!mediaAssetId);
  const data = { mediaAssetIds: filteredMediaAssetIds };

  return callWebUtils(this, "getMultipleMediaAssetByIds", [data]);
});

Actions.deleteMultipleMediaAssets.listen(function (mediaAssetIds) {
  return callWebUtils(this, "deleteMultipleMediaAssets", [mediaAssetIds]);
});

export default Actions;
